export default {
      id: "relativeHumidity-usage",
      viewBox: "0 0 14.349 22.347",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#relativeHumidity",
      toString: function () {
        return this.url;
      }
    }